import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";
import { Mutation } from "vuex-class";

import EditableTable from '@/../bower_components/teknisavuecomponents/components/grids/EditableTable.vue';

import AlteSalarioController from '@/assets/ts/controller/AlteSalarioController';
import AlteOcupacaoController from '@/assets/ts/controller/AlteOcupacaoController';
import Util from "@/../bower_components/teknisavuecomponents/assets/utils/Util";

@Component({
  name: 'DetalhesQuadroGeral',
  components: {
    EditableTable,
  },
})
export default class DetalhesQuadroGeral extends Vue {
  // [ PROPS ]
  @Prop({ default: null })
  private nrVinculo: number;

  @Prop({ default: null })
  private nmVinculo: string;

  @Prop({ default: false })
  private isVisible: boolean;
  // [ PROPS ]

  // [ DATA ]
  private screen = {
    titleTemplate: 'Detalhes - @',
    title: '',
  };

  private actions = {
    close: this.close,
    save: () => {},
    saveDisabled: false,
  }

  private tab = 0;

  private readonly tabs = {
    ALTE_SALARIO: {
      tab: 0,
      icon: 'mdi-cash',
      description: 'Alterações Salariais',
      gridGetDataAction: this.getAltesalario,
      disabled: false,
      grid: {
        actions: [],
        columns: [
          {
            text: 'Dt. Alteração',
            value: 'DTALTESALARIO',
            type: 'text',
          },
          {
            text: 'Dt. Base',
            value: 'DTBASEDISSIDIO',
            type: 'text',
          },
          {
            text: 'Tipo Alteração',
            value: 'NMTIPOALTERA',
            type: 'text',
          },
          {
            text: 'Salário',
            value: 'VRSALARIO',
            type: 'text',
            align: 'right',
          },
          {
            text: 'Diferença Real',
            value: 'VRDIFERENCAREAL',
            type: 'text',
            align: 'right',
          },
          {
            text: 'Percentual Real (%)',
            value: 'VRPERCREAL',
            type: 'text',
            align: 'right',
          }
        ],
        dense: true,
        loading: false,
        tableReadonly: true,
        reloadOnCreation: true,
        rows: [],
        toolbarActions: [
          {
            name: 'reload',
            label: 'Atualizar',
            icon: 'mdi-refresh',
            onClick: this.reloadGridTab,
          },
        ],
        rowsOnUpdate: () => {},
      }
    },
    ALTE_OCUPACAO: {
      tab: 1,
      icon: 'mdi-briefcase',
      description: 'Alterações de Ocupação',
      gridGetDataAction: this.getAlteocupacao,
      disabled: false,
      grid: {
        actions: [],
        columns: [
          {
            text: 'Nr. Alte Ocupação',
            value: 'NRALTEOCUPACAO',
            type: 'text',
          },
          {
            text: 'Nr. Ocupação',
            value: 'NROCUPACAOM',
            type: 'text',
          },
          {
            text: 'Ocupação',
            value: 'NMOCUPACAOH',
            type: 'text',
          },
          {
            text: 'Faixa',
            value: 'DSFAIXA',
            type: 'text',
          },
          {
            text: 'Início Ocupação',
            value: 'DTINIOCUPACAO',
            type: 'text',
          },
          {
            text: 'Fim Ocupação',
            value: 'DTFIMOCUPACAO',
            type: 'text',
          }
        ],
        dense: true,
        loading: false,
        tableReadonly: true,
        reloadOnCreation: true,
        rows: [],
        toolbarActions: [
          {
            name: 'reload',
            label: 'Atualizar',
            icon: 'mdi-refresh',
            onClick: this.reloadGridTab,
          },
        ],
        rowsOnUpdate: () => {},
      }
    },
  };
  // [ DATA ]

  // [ COMPUTED ]
  private get currentTab(): any {
    return this.getCurrentTab();
  }

  private get alteSalarioTab(): any {
    return this.tabs.ALTE_SALARIO;
  }

  private get alteSalarioGrid(): any {
    return this.alteSalarioTab.grid;
  }

  private get alteOcupacaoTab(): any {
    return this.tabs.ALTE_OCUPACAO;
  }

  private get alteOcupacaoGrid(): any {
    return this.alteOcupacaoTab.grid;
  }
  // [ COMPUTED ]

  // [ STORE ]
  @Mutation('controlPopUp')
  private controlPopUp: (popUp: {[key: string]: any, popUp: string}) => void;
  // [ STORE ]

  // [ EMIT ]
  @Emit('close-popup')
  private close() {
    this.resetTab();
  }
  // [ EMIT ]

  // [ METHODS ]
  @Watch('isVisible', { immediate: true, deep: true })
  private isVisibleOnChange(newValue: boolean) {
    if (newValue) {
      this.onShowPopup();
    }
  }

  private onShowPopup() {
    this.reloadAllGridTabs();
    this.updatePopupTile();
  }

  private async reloadGridTab() {
    const currentTab = this.currentTab;
    if (Util.isEmptyOrBlank(currentTab)) {
      return;
    }

    const currentGrid = this.currentTab.grid;

    currentGrid.loading = true;
    try {
      currentGrid.rows = await currentTab.gridGetDataAction();
    } catch (err) {
      currentGrid.rows = [];
    } finally {
      currentGrid.loading = false;
    }
  }

  private async reloadAllGridTabs(): Promise<void> {
    const gridTabs = this.getGridTabs();

    for (const gridTab of gridTabs) {
      const currentGrid = gridTab.grid || {};
      currentGrid.loading = true;
      currentGrid.rows = [];
    }

    for (const gridTab of gridTabs) {
      const currentGrid = gridTab.grid || {};
      try {
        currentGrid.rows = await gridTab.gridGetDataAction();
      } finally {
        currentGrid.loading = false;
      }
    }
  }

  private getGridTabs(): any[] {
    const gridTabs = [];
    for (const tabIndex in this.tabs) {
      const tab = this.tabs[tabIndex];
      if (tab.grid && tab.gridGetDataAction) {
        gridTabs.push(tab);
      }
    }

    return gridTabs;
  }

  private getCurrentTab() {
    for (const tabIndex in this.tabs) {
      const currentTab = this.tabs[tabIndex];
      if (currentTab.tab === this.tab) {
        return currentTab;
      }
    }

    return {};
  }

  private updatePopupTile(): void {
    this.screen.title = this.screen.titleTemplate.replace('@', this.nmVinculo);
  }

  private resetTab() {
    this.tab = 0;
  }

  private async getAlteocupacao() {
    return await AlteOcupacaoController.getAlteocupacao(this.nrVinculo, false);
  }

  private async getAltesalario() {
    return await AlteSalarioController.getAltesalario(this.nrVinculo, false);
  }
  // [ METHODS ]
}